import React, {Component} from 'react';
import './chatLandingSearchXA3.scss';
import Hidden from "@material-ui/core/Hidden";
import {withStyles} from "@material-ui/core";
import {SearchDeskTop} from "./chatSearch-XA3-Icons";
import { isSafari,isFirefox, isChrome , isMobile} from 'react-device-detect';

const styles = theme => ({
  searchArea: {
    width: '60%',
    [theme.breakpoints.down('sm')]: {
      width: '90%'
    }
  },

  'input': {
    '&::placeholder': {

      [theme.breakpoints.only('xs')]: {
        width: '263px',
        height: '20px',
        fontFamily: 'DMSans',
        fontSize: 14,
        fontWeight: 300,
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 1.43,
        letterSpacing: 'normal',
        color: '#62626c'
      }

    }
  }

});

class chatLandingSearchXA3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled:true,
      searchText: ''
    };
   // this.userName="";

    this.clearSearch = this.clearSearch.bind(this);
    this.onButtonClicked = this.onButtonClicked.bind(this);
    this.onKeyPressed = this.onKeyPressed.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);

    this.searchInputRef = React.createRef();
    this.searchSpanRef = React.createRef();
 /* function alertAfter3Seconds() {
            let  abc =document.getElementById('xfinitychatHeader');
            this.userName = abc.getAttribute('first-name');
            if((this.userName != null && this.userName.length >0)){
            document.getElementById('greetNameXA3').innerHTML = "Hi "+this.userName+"!";
             }
      }
        setTimeout(alertAfter3Seconds,6000);*/
  }

    focus=()=>
    {
      // document.getElementById('searchWrapperContainer').focus();
    };

  render() {
    const classes = this.props.classes;
    const iphoneCheck = navigator.userAgent.includes('CriOS') && isMobile;

    let val = {
      "eventName":"XA Send",
      "eventAction": this.state.searchText
    };
    const inputStyle = {
      container: {
        fontFamily: "DMSans",
        fontSize: "14px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.43",
        letterSpacing: "normal",
        color: "#62626c",
        margin: "10px 147px 14px 10px",
        width: "70%",
        height: "30px",
        border: "0px",
        zIndex: "3",
        background: "transparent"
      }

    };

    return <div onLoad={this.focus} id="parentSearchContainer"

                onMouseMove={(event)=>{
                  this.onMouseEnter(event);}}
                onMouseOver={(event)=>{
                  this.onMouseEnter(event);}}
                onMouseEnter={(event)=>{
                  this.onMouseEnter(event);}}
               className="chatLanding-Search-XA3">

        <SearchDeskTop  width={816} height={496} focusable={false} userName={this.userName}/>
      <div  className={`${classes.searchArea} search-area`} data-tracking='{"container":["search-area"]}'>
        <div id="searchContainer"
               className={'searchInputContainer leftPadding'} >
        <Hidden xsDown>
        {isSafari || iphoneCheck ? <span className={this.state.disabled ? "safari-search-label" : "safari-search-label-off"} >{this.props.placeHolder}</span> : null}
          <input style={isSafari || iphoneCheck ? inputStyle.container : null} className={isSafari ? 'safari-search': iphoneCheck ? 'mobile-safari-search' : 'search'} role="textbox" aria-label="Enter your support comment here"  autoComplete="off" tabIndex="0" placeholder={!isSafari ? this.props.placeHolder : null} type="text"

                 ref={this.searchInputRef}
                 onKeyPress={(event)=>{this.onKeyPressed(event);}}
                 onChange={this.onSearchTextChange.bind(this)}
                 data-tracking='{"container":["search-box"]}'
          />
        </Hidden>
        <Hidden smUp>
            { isSafari ? <span className={this.state.disabled ? "safari-search-label" : "safari-search-label-off"} >{this.props.placeHolder}</span> : null  }
              <input  data-tracking style={isSafari ? inputStyle.container : null} role="textbox" aria-label="Enter your support comment here"  autoComplete="off" tabIndex="0" className={'searchSmall'} type="text"  placeholder={!isSafari ? this.props.placeHolder : null}
                 value={this.state.searchText}
                 ref={this.searchInputRef}
                 onKeyPress={(event)=>{
                 this.onKeyPressed(event);}}
                 onChange={this.onSearchTextChange.bind(this)}/>
        </Hidden>
        <Hidden xsDown>
          <button data-tracking= {JSON.stringify(val)}
              role="button" aria-label="Send" aria-disabled={this.state.disabled}
              className={this.state.searchText ? 'button filled' : 'button'}
              onClick={(event)=>{this.onButtonClicked(event,this.state.searchText);}} />
        </Hidden>
        <Hidden smUp>
          <button  data-tracking= {JSON.stringify(val)} role="button" aria-label="Send" aria-disabled={this.state.disabled}
              className={this.state.searchText ? 'button-small filled' : 'button-small'}
              onClick={(event)=>{this.onButtonClicked(event,this.state.searchText);}}/>
        </Hidden>
      </div>
      </div>
    </div>;
  }


  clearSearch()
  {
    this.setState({searchText: ''});
    this.setState({disabled:true});
      if(this.searchInputRef.current!=null)
      this.searchInputRef.current.value='';


  }

  onButtonClicked(event,searchText)
  {
    if( searchText!=null && searchText.length>0) {
      this.props.defaultEvent(searchText, 'utterance');
    }
  }

  onKeyPressed(event){

    if (event.keyCode === 9) {
    if( document.getElementById('searchField')!=null) {
      document.getElementById('searchField').classList.remove('searchMouse');
    }
    }
    if (event.shiftKey && event.charCode === 13) {
      return true;
    }
    if (event.charCode === 13) {

      event.preventDefault();
      if (event.target.value != null) {
        if (event.target.value.length > 0) {
          this.setState({searchText: event.target.value});
          this.setState({disabled:true});
          this.props.defaultEvent(event.target.value, 'utterance');
          return false;
        }
      }

    }
  }

  onMouseEnter(event) {
    if( document.getElementById('searchField')!=null) {
      document.getElementById('searchField').classList.add('searchMouse');
    }
  }

  onMouseLeave(){
    if( document.getElementById('searchField')!=null) {
      document.getElementById('searchField').classList.remove('searchMouse');
    }
  }



  onSearchTextChange(event) {

    this.setState({searchText: event.target.value});
    if(event.target.value.length>0)
    {
      this.setState({disabled:false});
    }
    else {
      this.setState({disabled:true});
    }
  }
}

export default withStyles(styles)(chatLandingSearchXA3);
